import { render, staticRenderFns } from "./LandedCostParamsModal.vue?vue&type=template&id=24547614&scoped=true&"
import script from "./LandedCostParamsModal.vue?vue&type=script&lang=js&"
export * from "./LandedCostParamsModal.vue?vue&type=script&lang=js&"
import style0 from "./LandedCostParamsModal.vue?vue&type=style&index=0&id=24547614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24547614",
  null
  
)

export default component.exports